import { RATING_ICONS } from './Place/constants'

export const RATING_TYPES = {
  totalAmount: 'TOTAL_AMOUNT',
  count: 'COUNT',
  uniqueClientsCount: "UNIQUE_CLIENTS_COUNT",
};

export const RATING_CONFIG_BY_TYPE = {
  [RATING_TYPES.count]: {
    ratingParam: 'Количество выдач',
    ratingName: 'По количеству выдач',
    scoreUnits: '',
    ratingIcon: RATING_ICONS.boat,
  },
  [RATING_TYPES.totalAmount]: {
    ratingParam: 'Объем выдач',
    ratingName: 'По объему выдач',
    scoreUnits: 'млн ₽',
    ratingIcon: RATING_ICONS.boat,
  },
  [RATING_TYPES.uniqueClientsCount]: {
    ratingParam: 'Количество клиентов',
    ratingName: 'По количеству клиентов',
    scoreUnits: '',
    ratingIcon: RATING_ICONS.boat,
  },
};

